var map = {
	"./site-logo-desktop-footer.svg": 87629,
	"./site-logo-drawer-mobile.svg": 28277,
	"./site-logo-drawer.svg": 27702,
	"./site-logo-tv.svg": 4771,
	"./site-logo-wrapper-mobile-scrolled.svg": 98162,
	"./site-logo-wrapper-mobile.svg": 97501,
	"./site-logo-wrapper-scrolled.svg": 9535,
	"./site-logo-wrapper.svg": 36990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38874;